var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPentharaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 128,
    viewBox: "0 0 512 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.8868 13.9374V26.86H105.431V39.4047H72.8868V53.6484H108.825V66.1948H58.9258V1.39258H108.825V13.9374H72.8868V13.9374Z",
    fill: "#484848"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.055 1.39258H131.92L163.144 43.2723V1.39258H177.105V66.1948H163.144L131.92 24.3132V66.1948H118.055V1.39258V1.39258Z",
    fill: "#484848"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M304.213 1.39258V66.1948H290.349V39.4065H260.825V66.1948H246.957V1.39258H260.825V26.86H290.349V1.39258H304.213Z",
    fill: "#484848"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M353.715 44.2154L344.095 20.5389L334.473 44.2154H353.715ZM358.528 56.006H329.663L325.512 66.193H309.949L336.36 1.39258H351.924L378.336 66.193H362.676L358.528 56.006V56.006Z",
    fill: "#484848"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M397.95 32.425H411.718C418.608 32.425 423.321 28.8398 423.321 23.2765C423.321 17.7097 418.608 14.1264 411.718 14.1264H397.95V32.425V32.425ZM423.037 66.1948L408.228 45.1586H397.95V66.1948H384.082V1.39258H413.228C427.283 1.39258 437.659 10.4475 437.659 23.2765C437.659 32.8965 431.809 40.4432 422.945 43.5569L438.884 66.1948H423.037V66.1948Z",
    fill: "#484848"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M486.596 44.2154L476.976 20.5389L467.354 44.2154H486.596ZM491.411 56.006H462.545L458.395 66.193H442.832L469.242 1.39258H484.805L511.218 66.193H495.559L491.411 56.006V56.006Z",
    fill: "#484848"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 66.1811V21.9219H49.5197C44.9476 29.8203 36.4192 35.149 26.6527 35.1905L26.5377 35.1909H13.2688V66.1811H0V66.1811Z",
    fill: "#484848"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5377 0C36.3523 0 44.9298 5.33943 49.5197 13.2688H0V0H26.5377V0Z",
    fill: "#484848"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M215.423 23.3125H202.551V66.247H215.423V23.3125Z",
    fill: "#484848"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.37 15.0053H190.832V1.73633H240.352C235.78 9.6349 227.251 14.9637 217.485 15.005L217.37 15.0053Z",
    fill: "#484848"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2055 92.3642V85.5898H39.9453V126.451H70.2055V119.677H47.256V109.021H68.0394V102.247H47.256V92.3642H70.2055Z",
    fill: "#484848",
    fillOpacity: 0.75
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M102.69 127.182C108.603 127.182 113.989 124.626 117.853 120.526L112.701 115.647C110.184 118.563 106.612 120.407 102.69 120.407C95.2547 120.407 88.9904 113.862 88.9904 106.007C88.9904 98.2122 95.2547 91.6669 102.69 91.6669C106.554 91.6669 110.184 93.5115 112.642 96.4272L117.853 91.4886C113.989 87.4479 108.603 84.8926 102.69 84.8926C91.2151 84.8926 81.5625 94.5231 81.5625 106.007C81.5625 117.492 91.2151 127.182 102.69 127.182V127.182Z",
    fill: "#484848",
    fillOpacity: 0.75
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M156.735 85.5898V102.247H136.647V85.5898H129.336V126.451H136.647V109.021H156.735V126.451H164.046V85.5898H156.735Z",
    fill: "#484848",
    fillOpacity: 0.75
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M178.762 126.451H186.072V97.7233L207.331 126.451H214.584V85.5898H207.331V114.318L186.072 85.5898H178.762V126.451Z",
    fill: "#484848",
    fillOpacity: 0.75
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M246.447 127.182C257.867 127.182 267.52 117.492 267.52 106.007C267.52 94.5231 257.867 84.8926 246.447 84.8926C234.97 84.8926 225.316 94.5231 225.316 106.007C225.316 117.492 234.97 127.182 246.447 127.182ZM246.447 120.407C239.01 120.407 232.744 113.862 232.744 106.007C232.744 98.2122 239.01 91.6669 246.447 91.6669C253.826 91.6669 260.033 98.2122 260.033 106.007C260.033 113.862 253.826 120.407 246.447 120.407V120.407Z",
    fill: "#484848",
    fillOpacity: 0.75
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M287.018 119.677V85.5898H279.766V126.451H307.684V119.677H287.018Z",
    fill: "#484848",
    fillOpacity: 0.75
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M334.209 127.182C345.628 127.182 355.281 117.492 355.281 106.007C355.281 94.5231 345.628 84.8926 334.209 84.8926C322.731 84.8926 313.078 94.5231 313.078 106.007C313.078 117.492 322.731 127.182 334.209 127.182ZM334.209 120.407C326.772 120.407 320.506 113.862 320.506 106.007C320.506 98.2122 326.772 91.6669 334.209 91.6669C341.588 91.6669 347.795 98.2122 347.795 106.007C347.795 113.862 341.588 120.407 334.209 120.407Z",
    fill: "#484848",
    fillOpacity: 0.75
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M386.433 110.049H396.448V117.49C393.929 119.336 390.65 120.407 387.604 120.407C380.108 120.407 373.783 113.859 373.783 106.008C373.783 98.2144 380.108 91.6669 387.604 91.6669C391.528 91.6669 395.862 93.4525 398.377 96.4288L403.583 91.4886C399.722 87.3884 393.461 84.8926 387.604 84.8926C376.067 84.8926 366.355 94.5239 366.355 106.008C366.355 117.49 376.067 127.182 387.604 127.182C393.461 127.182 399.722 124.626 403.583 120.526V103.988H386.433V110.049V110.049Z",
    fill: "#484848",
    fillOpacity: 0.75
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M424.6 85.5898H417.348V126.451H424.6V85.5898Z",
    fill: "#484848",
    fillOpacity: 0.75
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M469.155 92.3642V85.5898H438.895V126.451H469.155V119.677H446.205V109.021H466.989V102.247H446.205V92.3642H469.155Z",
    fill: "#484848",
    fillOpacity: 0.75
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M496.896 127.182C506.499 127.182 511.997 122.012 511.997 114.695C511.997 107.257 506.382 104.52 498.009 102.616C491.625 101.128 488.637 99.9382 488.637 96.606C488.637 93.7499 491.39 91.2504 495.432 91.2504C499.415 91.2504 503.456 92.9763 506.967 96.0705L510.944 90.5969C506.909 87.0912 502.109 84.8926 495.725 84.8926C487.234 84.8926 481.268 90.1215 481.268 97.2605C481.268 104.936 487.058 107.376 495.373 109.34C501.816 110.887 504.686 112.017 504.686 115.409C504.686 118.325 502.109 120.824 497.13 120.824C491.859 120.824 487.585 118.682 483.9 115.29L479.688 120.586C484.134 124.805 489.985 127.182 496.896 127.182V127.182Z",
    fill: "#484848",
    fillOpacity: 0.75
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8251 99.1562H7.65234V126.417H15.8251V99.1562Z",
    fill: "#484848",
    fillOpacity: 0.75
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0645 94.0089H0.214844V85.584H31.6566C28.7536 90.5989 23.3387 93.9824 17.1375 94.0087L17.0645 94.0089Z",
    fill: "#484848",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPentharaLogo);
export default __webpack_public_path__ + "static/media/PentharaLogo.8ef6d8744e4ec0873b70ff02b6dd541c.svg";
export { ForwardRef as ReactComponent };